import React, { useCallback, useMemo, useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
// eslint-disable-next-line import/no-cycle
import { useTranslation } from 'react-i18next';
import DocumentTypeMaster from './DocumentTypeMaster';
import { useComponent } from '../../UserSetting/UsersLibrary/UserRights';

export const Context = React.createContext();
function ContextWrapper({ OpenReArrangeFunction, state, setState, documentMasterTypes, handleDropdownChange }) {
  const { t } = useTranslation('common');
  const {
    SystemMastersDetails: { documentTypeList },
    Users: { logInRights, documentsList },
  } = useSelector((reducer) => reducer);
  const { CheckActionPermission } = useComponent();

  const MasterAddEditAccess = CheckActionPermission(logInRights, 'masters', 'documentType', 'addEdit');
  const MasterDeleteAccess = CheckActionPermission(logInRights, 'masters', 'documentType', 'delete');
  const [cards, setCards] = useState([]);
  const [statusCards, setStatusCards] = useState([]);

  const [formState, setFormState] = useState({
    values: {},
    errors: {},
    isSubmitted: false,
    disableBtn: false,
    isLoading: false,
  });
  const [productType, setProductType] = useState([]);
  const [status, setStatus] = useState([]);

  const validateInput = useCallback(
    (moduleName, id) => {
      if (moduleName.length === 0) {
        setFormState((prev) => ({ ...prev, errors: { ...prev.errors, [id]: t('DOCUMENT_TYPE.DOCUMENT_TYPE_REQUIRED') } }));
        return;
      }
      const doesExist = cards.find((obj) => obj.name === moduleName && obj._id !== id);
      if (doesExist) {
        setFormState((prev) => ({ ...prev, errors: { ...prev.errors, [id]: t('DOCUMENT_TYPE.THIS_ENTRY_ALREADY_EXIST') } }));
      } else {
        setFormState((prev) => {
          return { ...prev, errors: {} };
        });
      }
    },
    [cards],
  );

  const updateSubmitState = useCallback((val) => {
    setFormState((prev) => ({ ...prev, isSubmitted: val, values: {}, errors: {} }));
  }, []);

  const setFormValues = useCallback(
    (val, id) => {
      setFormState((prev) => ({ ...prev, values: { ...prev.values, [id]: val } }));
      validateInput(val, id);
    },
    [validateInput],
  );
  useEffect(() => {
    if (documentMasterTypes?.value === 'supplier') {
      setCards(documentsList);

      if (state?.rearrangeModal === 'documentType') {
        setState((prev) => ({
          ...prev,
          rearrangeData: [...documentsList],
        }));
      }
    } else {
      setCards(documentTypeList);
      if (state?.rearrangeModal === 'documentType' || state?.rearrangeModal === 'manualDocumentType') {
        setState((prev) => ({
          ...prev,
          rearrangeData: [...documentTypeList],
        }));
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [documentTypeList, documentsList, documentMasterTypes, state?.rearrangeModal]);

  const onDropSelectionChange = (e, i) => {
    const freeTextDropdownData = [...cards];
    freeTextDropdownData[i] = {
      ...cards[i],
      status: e,
    };
    setCards(freeTextDropdownData);
  };

  const updateArray = useCallback((val, _id) => {
    if (_id) {
      setCards((prev) => prev.map((obj) => (obj._id === _id ? { ...obj, ...val } : obj)));
      return null;
    }
    setCards((prev) => [...prev, { _id, ...val }]);
  }, []);

  const addNewItem = useCallback(() => {
    setCards((prev) => [...prev, { _id: `_id${prev.length}`, name: '' }]);
  }, []);

  const removeFromArray = useCallback((_id) => {
    setCards((prev) => prev.filter((obj) => obj._id !== _id));
    setFormState({
      values: {},
      errors: {},
      isSubmitted: false,
      disableBtn: false,
      isLoading: false,
    });
  }, []);

  const value = useMemo(
    () => ({
      cards,
      updateArray,
      addNewItem,
      removeFromArray,
      updateSubmitState,
      formState,
      setFormValues,
      MasterAddEditAccess,
      MasterDeleteAccess,
      OpenReArrangeFunction,
      setFormState,
      documentMasterTypes,
      handleDropdownChange,
      setProductType,
      productType,
      status,
      setStatus,
      statusCards,
      setStatusCards,
      onDropSelectionChange,
    }),
    [
      cards,
      updateArray,
      addNewItem,
      removeFromArray,
      updateSubmitState,
      formState,
      setFormValues,
      MasterAddEditAccess,
      MasterDeleteAccess,
      OpenReArrangeFunction,
      setFormState,
      documentMasterTypes,
      handleDropdownChange,
      setProductType,
      productType,
      status,
      setStatus,
      statusCards,
      setStatusCards,
      onDropSelectionChange,
    ],
  );

  return (
    <Context.Provider value={value}>
      <DocumentTypeMaster />
    </Context.Provider>
  );
}

export default ContextWrapper;
